import { render } from "./ProcessSteps.vue?vue&type=template&id=65bc96ac&scoped=true"
import script from "./ProcessSteps.vue?vue&type=script&lang=js"
export * from "./ProcessSteps.vue?vue&type=script&lang=js"

import "./ProcessSteps.vue?vue&type=style&index=0&id=65bc96ac&scoped=true&lang=css"

import exportComponent from "/Users/edvinasjuck/PhpstormProjects/arunvilkasa.lt/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65bc96ac"]])

export default __exports__